import {SchemaInterface} from "./interfaces/schema/SchemaInterface";
import {FieldInterface} from "@api/models/interfaces/schema/FieldInterface";

export class Schema implements SchemaInterface {
    id = '';
    fields = [];

    constructor(data: SchemaInterface) {
        Object.assign(this, data);
    }

    fieldByName(name: string): FieldInterface | undefined {
        return this.fields.find((item: FieldInterface) => item.name == name);
    }

    refType(field: FieldInterface): string {
        return field.type.replace('ref ', '')
            .replace('[','')
            .replace(']', '')
            .trim();
    }
}